import { deleteDraftFx, getDraftsFx } from './model';

deleteDraftFx.doneData.watch(() => {
    getDraftsFx(null);
});
